import { UpdateTermineFormProps } from '@/domain/termine/features/UpdateTermin/shared';
import WeekdayOccurrence from '@/domain/termine/features/UpdateTermin/shared/components/WeekdayOccurence';
import { Field } from '@e2n/ui';
import { useTranslation } from 'react-i18next';

export function WeekdayOccurrenceSelectFormField({
  form,
}: UpdateTermineFormProps) {
  const { t } = useTranslation();

  return (
    <form.Field name="wochentagAuftreten">
      {(field) => (
        <Field className="flex flex-col w-full gap-1">
          <label className="text-neutrals-900 text-xs font-bold">
            {t('domain.termine.sheet.fields.jeden')}
          </label>
          <WeekdayOccurrence
            value={field.state.value ?? undefined}
            onChange={field.handleChange}
            form={form}
          />
        </Field>
      )}
    </form.Field>
  );
}
